import { useRef } from 'react';
import styles from './FilePicker.module.scss';

type Props = {
    accept?: string;
    getFile?: (file: File) => void;
    children: React.ReactNode;
    style?: React.CSSProperties;
};

const FilePicker = ({ accept = '*', getFile, style, children }: Props) => {
    const imgPickerRef = useRef<HTMLInputElement | null>(null);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file: File | null = event.target.files ? event.target.files[0] : null;

        if (getFile && file) {
            getFile(file);
        }
    };

    const pickFile = () => {
        if (imgPickerRef) {
            imgPickerRef.current?.click();
        }
    };

    return (
        <div style={{ cursor: 'pointer' }}>
            <input
                className={styles.fileInput}
                ref={imgPickerRef}
                type="file"
                accept={accept}
                onChange={handleChange}
                style={{ ...style }}
            />
            <span onClick={pickFile}>{children}</span>
        </div>
    );
};

export default FilePicker;
